import dropzone from 'react-dropzone'
import React, { Component } from 'react'
import { Container } from 'components/Layout'
import Button from 'components/Button'
import cn from 'classnames'
import s from './FileUploadModal.scss'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

const Dropzone = dropzone.default

export default class FileUploadModal extends Component {
  onDrop = filesToUpload => {
    const {
      uploadType,
      uploadFile,
      uploadAudio,
      uploadAudioForPorta,
      modalConfirm,
      name,
    } = this.props

    const uploadFunc = {
      audio: uploadAudio,
      file: uploadFile,
      audioForPorta: uploadAudioForPorta,
    }

    if (uploadType === 'audioForPorta') {
      uploadFunc[uploadType]({
        id: name,
        file: filesToUpload[0],
      }).then(({ value }) => {
        modalConfirm({
          name: value.data.name,
          original: value.data.original,
          converted: value.data.converted,
        })
      })
    } else {
      uploadFunc[uploadType]({
        id: name,
        file: filesToUpload[0],
      }).then(({ value }) => {
        modalConfirm({
          name: filesToUpload[0].name,
          id: value.data.hash,
        })
      })
    }
  }
  render() {
    const { modalCancel, name, loading } = this.props

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Upload a File</div>
          <div style={{ position: 'relative' }}>
            <Dropzone id={name} className={s.dropzone} onDrop={this.onDrop}>
              Click or Drag a file here
            </Dropzone>
            {loading && <LoadingOverlay />}
          </div>
          <div className={cn(sLay['layout-column'], sLay['layout-align-start-center'])}>
            <Button onClick={modalCancel} plain className={sMarg.mt30}>
              Cancel
            </Button>
          </div>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/FileUploadModal/FileUploadModal.jsx